import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: false,
    type: 'buses',
    apiUrl: 'https://buses.gateway.test.todotix.net/',
    front_url: 'https://socio.testing.clubbolivar.com/bypass-login',
    vouchers_url: 'https://buses.vouchers.test.todotix.net/',

    title: 'Buses',
    subtitle: 'Admin Membresías',
    description: `"Buses - Admin Membresías" es un sitio en el que puedes administrar el sitio web de Buses`,
    keywords: 'Buses, Admin Membresías',
    yearProyect: '2024',

    imgLogo: '/assets/img/logo.png',
    imgLogoSVG: '/assets/img/logo.svg',
    imgLogoBig: '/assets/img/logo-big.png',

    header: true,
    sidebar: true,
    footer: true,

    authType: 'auth-2',
    authGoogle: false,
    authFacebook: false,
    authApple: false,
    authGithub: false,

    logoutTime: {
      active:false, //boolen para habiltar
      time: 1, //tiempo de inactividad, de 1 = 1 minuto
    },

    authRedirect: '/',

    //* Firebase
    firebase: {
        "projectId":"clubbolivar-membresias",
        "appId":"1:924925915724:web:9f327aa12495b5d7c9fae9",
        "storageBucket":"clubbolivar-membresias.appspot.com",
        "apiKey":"AIzaSyBn7I3w7JFAJcP-AVJNWhht25jhyGUgN2M",
        "authDomain":"clubbolivar-membresias.firebaseapp.com",
        "messagingSenderId":"924925915724",
        "measurementId":"G-J741BLEVFD",
    }
};
